var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.14217C9 7.40579 9.59695 6.80884 10.3333 6.80884C11.8061 6.80884 13 8.00275 13 9.4755C13 10.9483 11.8061 12.1422 10.3333 12.1422C9.59695 12.1422 9 11.5452 9 10.8088V8.14217Z",
    stroke: "#E6E6F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.14217C5 7.40579 4.40305 6.80884 3.66667 6.80884C2.19391 6.80884 1 8.00275 1 9.4755C1 10.9483 2.19391 12.1422 3.66667 12.1422C4.40305 12.1422 5 11.5452 5 10.8088V8.14217Z",
    stroke: "#E6E6F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.47546V7.47546C1 4.16176 3.68629 1.47546 7 1.47546C10.3137 1.47546 13 4.16176 13 7.47546V10.7062C13 12.0451 13 12.7146 12.7651 13.2366C12.4977 13.8307 12.0219 14.3064 11.4278 14.5739C10.9058 14.8088 10.2363 14.8088 8.89744 14.8088H7",
    stroke: "#E6E6F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.c8c2a7d0dba2055aa6dca4ed9ff55ab7.svg";
export { ForwardRef as ReactComponent };